import { AlertTriangle, ScanSearch } from "lucide-react";
import { REG_ROWS, fromScan, displayReg, latestScan } from "@/lib/regMap";

// Admin view: AI-read values vs what the seller confirmed. AI is not proof of registration/ownership.
export function AdminRegCheck({ papers, horse }) {
  const scanned = papers.filter((m) => m.scan);
  if (!scanned.length) return <p data-testid="admin-reg-check-none" className="mt-3 text-xs text-stone-500">Papers have not been read by AI.</p>;
  const scan = latestScan(papers);
  const found = scan ? fromScan(scan) : {};
  return (
    <div data-testid="admin-reg-check" className="mt-4 space-y-2">
      {scanned.filter((m) => m.scan.status !== "recognized").map((m) => (
        <p key={m.id} data-testid={`admin-reg-warn-${m.id}`} className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded p-2 flex gap-1.5">
          <AlertTriangle className="h-4 w-4 shrink-0" />{m.original_filename}: not confirmed as a registration certificate{m.scan.document_description ? ` (${m.scan.document_description})` : ""}.
        </p>
      ))}
      {scan && (
        <>
          <h3 className="text-sm font-semibold text-stone-800 flex items-center gap-1.5"><ScanSearch className="h-4 w-4 text-amber-800" />AI-read {scan.registry || ""} papers vs seller-confirmed</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-[11px] uppercase text-stone-400"><th className="py-1 pr-3">Field</th><th className="py-1 pr-3">AI read</th><th className="py-1">Seller confirmed</th></tr></thead>
              <tbody>
                {REG_ROWS.map(([k, label, s]) => {
                  const ai = displayReg(k, found[k]) || (scan.fields?.[s] || "");
                  const mine = displayReg(k, horse[k]);
                  const diff = !!ai && !!mine && String(ai).toLowerCase() !== String(mine).toLowerCase();
                  const unsure = (scan.uncertain || []).includes(s);
                  return (
                    <tr key={k} data-testid={`admin-reg-row-${k}`} className={`border-t border-stone-100 ${diff ? "bg-amber-50" : ""}`}>
                      <td className="py-1.5 pr-3 text-stone-600">{label}</td>
                      <td className="py-1.5 pr-3">{ai || <span className="text-stone-400">—</span>}{unsure && <span className="ml-1 text-[10px] text-amber-800">uncertain</span>}</td>
                      <td className="py-1.5">{mine || <span className="text-stone-400">—</span>}{diff && <span className="ml-1 text-[10px] font-semibold text-amber-800">differs</span>}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="text-[11px] text-stone-400">AI reading is a convenience only — not proof of registration or ownership.</p>
        </>
      )}
    </div>
  );
}
